export const getContentDispositionFilename = (response: any) => {
    return (
        response?.headers['content-disposition']
            ?.split('=')[1]
            ?.split(';')[0]
            ?.replaceAll('"', '') ?? 'UnknownFilename'
    )
    // replaceALL(") is needed for solving the issue with a chrome converting " to _ on Windows
}
